import React, { useState, useEffect,useContext } from 'react';
import Parse from 'parse';
import swal from 'sweetalert';
import Navbar from '../layouts/navbar';
import { AuthContext } from '../../auth';
import Replies from './replies.js';

const DisplayForum = (props) => {
    const [question, setQuestion] = useState('');
    const [description, setDescription] = useState('');
    const [user_id, setUser_Id] = useState('');
    const [replies, setReplies] = useState();
    const [createdAt, setCreatedAt] = useState('');
    const [comment, setComment] = useState('');
    const [logedinuser, setLogedinuser] = useContext(AuthContext);
    const [target,setTarget]= useState('');

    


    useEffect(() => {
        if(logedinuser!==null){
            setTarget("#commentmodal")
        }


        console.log("use effect");
        // console.log(props);
        const id = props.match.params.id;
        // console.log(id);

        const Forum = Parse.Object.extend("Forum");
        const query = new Parse.Query(Forum);
        query.get(id)
            .then((forum) => {
                // console.log(forum);
                setDescription(forum.get("description"));
                setQuestion(forum.get("question"));
                setUser_Id(forum.get("user_id"));
                setReplies(forum.get("replies").reverse());
                let d = forum.createdAt;
                setCreatedAt(d.toLocaleDateString());
                // console.log(replies);


            }, (error) => {
                console.log(error);
                swal("Oops!", "Seems like there is some problem with net", "error");
            })
    }, [])

    const handleSubmit = (event) => {
        console.log("submit");
        event.preventDefault();

        //making user:comment object
        let reply = { user: logedinuser,comment:comment };
        // console.log(reply);


        let newReplies = [...replies];
        newReplies.push(reply);
        


        const Forum = Parse.Object.extend("Forum");
        const query = new Parse.Query(Forum);
        const id = props.match.params.id;

        query.get(id)
        .then((forum) => {
            // console.log(forum);
            forum.set("replies",newReplies);
            forum.save().then((data)=>{
                console.log(data);
                swal("Addedd!", "Your Comment has been shared to the world", "success");
                setReplies(newReplies.reverse());
            }).catch((error=>{
                console.log(error);
                swal("Oops!", "Seems like we couldn't add your comment...Please try again in sometime", "error");
            }));
            
            setComment("");
            console.log(replies);


        }, (error) => {
            console.log(error);
            
                swal("Oops!", "Seems like we couldn't add your comment...Please try again in sometime", "error");

        })

        
    }
    

    const handleComment = () =>{
        if(logedinuser===null){
            return(
                <div>
                    {swal("Sorry!","You must log in to comment")}
                </div>
            )
        }
        
    }



    return (

        <div>
            {/* {console.log(target)} */}
        {console.log(replies)}
            <Navbar head="Forum" />

            <div className="container" style={{ marginTop: "50px" }}>
                <button type="button" id="myBtn" className="p-1" onClick={handleComment} 
                data-target={target} data-toggle="modal">
                    <i className="fas fa-plus-circle fa-3x"></i>
                    <p className="m-0 align-self-center ml-2">Comment</p>
                </button>

                <div className="card my-3 shadow-sm">
                    <div className="p-2" style={{ borderLeft: "solid 3px #65cdf0" }}>
                        <span className="mr-2"><img src="/assests/images/user.png" height="40" alt="user"></img></span>
                        <p className="mb-0" style={{ color: "#65cdf0", fontSize: "1.25em" }}>{user_id}</p>
                        <p className="text-secondary"> {createdAt}</p>

                        <h4 className="mb-0" style={{ color: "#65cdf0" }} >
                            {question}
                        </h4>


                        <div className="card-text">
                            {description}
                        </div>

                    </div>
                </div>
                <div className="ml-2">
                <Replies replies={replies}></Replies>
                </div>
                
                

            </div>

            <div className="modal fade" id="commentmodal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Your Comment</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form >
                                <div className="form-group">
                                    <textarea className="form-control" id="comment" value={comment} placeholder="Your text goes here" rows="7" onChange={(e) => setComment(e.target.value)}></textarea>
                                </div>
                                <div className="form-group text-right">
                                    <button type="button" className="btn" data-dismiss="modal">Dismiss</button>
                                    <button type="submit" onClick={handleSubmit} className="btn" data-dismiss="modal">Post</button>
                                </div>

                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default DisplayForum;